<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >分组ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >分组名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建人 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.nickname"
                  placeholder="请输入创建人名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建人ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入创建人ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
            <div class="flex align-items marginRight10">
              <el-button
                size="medium"
                type="primary"
                @click="handleCreate"
                style="margin-bottom: 10px"
                >新增</el-button
              >
            </div>
            <div class="flex align-items marginRight10">
              <el-button
                type="danger"
                size="medium"
                style="margin-bottom: 10px"
                @click="handleDeletes([...selectedRowKeys])"
                >删除</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="codeImage" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.codeImage"
          :preview-src-list="[row.codeImage]"
        >
        </el-image>
      </template>
      <template slot="userNum" slot-scope="{ row }">
        <div
          style="color: #00d8c3; cursor: pointer"
          @click="
            () => {
              memberDrawerVisible = true;
              memberTitle = row.name;
              memberForm.id = row.id;
            }
          "
        >
          {{ row.userNum }}
        </div>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <!-- <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="handleDetails(row)"
          >详情</el-button
        > -->
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete([row])"
          style="color: #ff001f !important"
          >删除</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleRecreateImage([row])"
          style="color: #46adf9 !important"
          >重新生成二维码</el-button
        >
      </template>
    </avue-crud>
    <!--修改/新增分组 抽屉 弹框-->
    <el-drawer
      v-if="drawerVisible"
      :title="`${form.id ? '修改分组' : '新增分组'}`"
      :visible.sync="drawerVisible"
      direction="rtl"
      :before-close="handleClose"
      custom-class="demo-drawer"
      :wrapperClosable="false"
    >
      <div class="demo-drawer__content">
        <avue-form ref="form" v-model="form" :option="formOption">
          <template slot="image">
            <FormImgUpload
              :url="form.image"
              @upload="upload"
              :limit="1"
              :maxSize="2"
              :accept="'.png,.jpg'"
              :multiple="true"
            />
            <div style="color: #c0c1c3">
              建议尺寸：50px*50px，图片格式：.png，.jpg
            </div>
          </template>
          <template slot="userId">
            <el-button v-if="!form.userId" @click="handleTable"
              >请选择</el-button
            >
            <el-button v-else @click="handleTable">{{
              form.userPhone
            }}</el-button>
          </template>
        </avue-form>
        <div class="demo-drawer__footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            :loading="showLoadingForm"
            @click="submit(form)"
            >确认</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      v-if="dialogVisible"
      :title="`${'选择用户'}`"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
    >
      <UserRadioTable @selectUserId="selectUserId" :userId="form.userId" />
    </el-dialog>

    <!-- 查看成员 弹框 抽屉  -->
    <el-drawer
      v-if="memberDrawerVisible"
      :title="`${memberTitle}`"
      :visible.sync="memberDrawerVisible"
      direction="rtl"
      :before-close="handleMemberClose"
      custom-class="demo-drawer"
      :wrapperClosable="false"
    >
      <div class="demo-drawer__content">
        <MemberTable
          ref="memberList"
          @memberId="memberId"
          @groupId="groupId"
          :id="memberForm.id"
        />
      </div>
    </el-drawer>
    <!-- 修改权限弹窗 -->
    <el-dialog
      v-if="memberDialogVisible"
      :title="`${'批量编辑成员'}`"
      :visible.sync="memberDialogVisible"
      width="45%"
      :before-close="handleMemberDialogClose"
      :close-on-click-modal="false"
    >
      <div>
        <div class="marginBottom20">
          <img
            v-for="(v, i) in gatewayUserList"
            :key="i"
            class="content_top_right_user"
            :src="v.avatarUrl"
            mode=""
            :style="{ zIndex: 100 + i }"
          />
        </div>
        <div class="marginBottom20">用户身份</div>
        <div class="marginBottom20">
          <el-radio-group
            v-model="memberForm.identityType"
            size="mini"
            @change="
              () => {
                memberForm.gatewayIds = [];
              }
            "
          >
            <el-radio-button label="2" border>管理员</el-radio-button>
            <el-radio-button label="3" border style="margin-left: 15px"
              >成员</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="marginBottom20">用户所属网关（多选）</div>
        <div class="marginBottom20">
          <el-checkbox-group
            v-if="memberForm.identityType == 3"
            v-model="memberForm.gatewayIds"
          >
            <el-checkbox-button
              v-for="item in gatewayList"
              :label="item.id"
              border
              style="margin-right: 15px"
              :key="item.id"
            >
              {{ item.name }}</el-checkbox-button
            >
          </el-checkbox-group>
          <el-checkbox-group v-else v-model="memberForm.gatewayIds">
            <el-checkbox-button
              label="0"
              border
              style="margin-right: 15px"
              key="0"
            >
              全部网关</el-checkbox-button
            >
          </el-checkbox-group>
        </div>
      </div>
      <div style="text-align: center">
        <el-button @click="handleMemberDialogClose">取消</el-button>
        <el-button
          type="primary"
          @click="submitMember(form)"
          :loading="showLoadingMemberForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加成员弹窗 -->
    <el-dialog
      v-if="groupAdduserDialogVisible"
      :title="`${'添加成员'}`"
      :visible.sync="groupAdduserDialogVisible"
      width="45%"
      :before-close="handleGroupAdduserDialogClose"
      :close-on-click-modal="false"
    >
      <GroupAdduserDialog :filteredList="filteredList" :gatewayList="gatewayList" :groupId="memberForm.id" @close="handleGroupAdduserDialogClose" />
    </el-dialog>
    
  </div>
</template>

<script>
import {
  groupList,
  groupAdd,
  groupDelete,
  groupDeletes,
  groupUpdate,
  groupView,
  userList,
  gatewayList,
  userUpdate,
  groupUserDeletes,
  groupRecreateCodeImage
} from "@/api/user/group";
import dayjs from "dayjs";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import UserRadioTable from "@/components/userRadioTable";
import MemberTable from "./components/memberTable";
import GroupAdduserDialog from "./components/groupAdduserDialog.vue";
export default {
  name: "index",
  components: {
    FormImgUpload,
    UserRadioTable,
    MemberTable,
    GroupAdduserDialog,
  },
  data() {
    return {
      searchData: {
        createTime: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "ID",
            prop: "groupId",
          },
          {
            label: "分组名称",
            prop: "name",
          },
          {
            label: "分组图片",
            prop: "image",
          },
          {
            label: "分组二维码",
            prop: "codeImage",
          },
          {
            label: "创建人",
            prop: "nickname",
          },
          {
            label: "创建人手机",
            prop: "phone",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "成员",
            prop: "userNum",
          },
        ],
      },

      drawerVisible: false,
      form: {
        id: "",
        userId: "",
        userPhone: "",
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "分组图片",
            prop: "image",
            type: "text",
            maxlength: 50,
            span: 24,
          },
          {
            label: "分组名称",
            prop: "name",
            // type: "text",
            maxlength: 12,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入分组名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "创建人",
            prop: "userId",
            // type: "text",
            maxlength: 11,
            span: 16,
            row: true,
            placeholder: "请选择",
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      memberForm: {
        id: "",
        identityType: "2",
        gatewayIds: [],
      },
      memberFormOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "分组图片",
            prop: "image",
            type: "text",
            maxlength: 50,
            span: 24,
          },
          {
            label: "分组名称",
            prop: "name",
            // type: "text",
            maxlength: 12,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入分组名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "创建人",
            prop: "userId",
            // type: "text",
            maxlength: 11,
            span: 16,
            row: true,
            placeholder: "请选择",
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      memberDrawerVisible: false, //成员抽屉
      memberDialogVisible: false, //编辑成员弹窗
      groupAdduserDialogVisible:false,//添加成员弹窗
      memberTitle: "", //
      memberType: 0, // 1 修改权限 2 踢出分组
      gatewayList: [], //修改权限网关列表
      gatewayUserList: [], //选中的用户数据
      showLoadingMemberForm: false, //提交防重
      filteredList:[],//已在选中分组中的用户列表
    };
  },
  created() {
    // this.searchData.userId = this.$route.query.id || ''
    // // this.onLoad()
    // console.log('1111111');
  },
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      groupList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 添加
    handleCreate() {
      this.form = {
        image: [],
        id: "",
      };
      this.drawerVisible = true;
    },
    // 关闭
    handleClose() {
      this.drawerVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //编辑
    async handleEdit(row) {
      console.log(row);
      this.form.id = row.id;
      this.drawerVisible = true;
      this.form = {
        id: row.id,
        image: row.image ? [row.image] : [],
        name: row.name,
        userId: row.createUserId,
        userPhone: row.phone,
      };
      console.log(this.form, "this.formthis.form");
    },

    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        groupDelete({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },
    // 批量删除
    handleDeletes(row) {
      if (!row.length) {
        this.$message.error("至少选择一个");
        return;
      }
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        groupDeletes({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },

    // 重新生成二维码
    handleRecreateImage(row) {
      if (!row.length) {
        this.$message.error("至少选择一个");
        return;
      }
      this.$confirm("确定重新生成吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        groupRecreateCodeImage({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("重新生成成功!");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },
    
    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },

    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (form.name.length > 12 || form.name.length < 2) {
            this.$message.success("名称长度2-12");
            return;
          }
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          // return
          if (form.id) {
            groupUpdate({
              ...form,
              image: form.image && form.image.length > 0 ? form.image[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.drawerVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          } else {
            groupAdd({
              ...form,
              image: form.image && form.image.length > 0 ? form.image[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.drawerVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          }
          // this.form.type = 1;
          // done()
        }
      });
    },
    //富文本框变化替换值
    editoChange(e) {
      this.form.details = e;
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },

    //选择用户id打开弹窗
    handleTable() {
      this.dialogVisible = true;
    },
    //关闭用户选择弹框
    handleDialogClose() {
      this.dialogVisible = false;
    },
    //选择用户id
    selectUserId(e) {
      console.log(e, "eeeeee");
      this.form.userId = e.id;
      this.form.userPhone = e.phone;
      this.dialogVisible = false;
    },

    // 选择成员 -- 修改权限
    async memberId(e, type) {
      if (!(e && e.length > 0)) {
        this.$message.error("请选择成员");
        return;
      }
      if (type == 1) {
        await gatewayList({
          id: this.memberForm.id,
        })
          .then((res) => {
            if (res.code === 200) {
              this.gatewayList = res.data;
            }
          })
          .catch(() => console.log(""));
        this.gatewayUserList = [...e];
        this.memberDialogVisible = true;
      }
      if (type == 2) {
        this.$confirm("确定踢出分组吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          groupUserDeletes(e.map((obj) => obj.id).join(","))
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("操作成功");
                setTimeout(() => {
                  this.resetForm();
                }, 500);
                this.onLoad();
              }
              this.memberDrawerVisible = false;
            })
            .catch(() => (this.memberDrawerVisible = false));
        });
      }
    },
    handleMemberClose() {
      this.memberDrawerVisible = false;
    },
    handleMemberDialogClose() {
      this.memberDialogVisible = false;
    },

    //添加成员
    async groupId(memberList) {
      this.filteredList = memberList
      await gatewayList({
          id: this.memberForm.id,
        })
          .then((res) => {
            if (res.code === 200) {
              this.gatewayList = res.data;
            }
          })
          .catch(() => console.log("error"));
      this.groupAdduserDialogVisible = true
    },
    //关闭添加成员弹窗
    handleGroupAdduserDialogClose(){
      this.groupAdduserDialogVisible = false
      //刷新成员列表
      this.$refs.memberList.onLoad();
    },

    //修改成员
    submitMember() {
      if (
        this.memberForm.identityType == 2 &&
        !(this.memberForm.gatewayIds.join(",") == "0")
      ) {
        this.$message.error("未选择网关");
        return;
      }
      if (
        this.memberForm.identityType == 3 &&
        !this.memberForm.gatewayIds.join(",")
      ) {
        this.$message.error("未选择网关");
        return;
      }
      this.showLoadingMemberForm = true;
      userUpdate({
        gatewayIds:
          this.memberForm.identityType == 2
            ? ""
            : this.memberForm.gatewayIds.join(","),
        identityType: this.memberForm.identityType,
        ids: this.gatewayUserList.map((obj) => obj.id),
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.drawerVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
            this.onLoad();
          }
          this.memberDialogVisible = false;
          this.showLoadingMemberForm = false;
          this.$refs.memberList.onLoad();
          this.memberForm.gatewayIds = [];
        })
        .catch(() => (this.showLoadingMemberForm = false));
    },
  },
};
</script>

<style scoped>
::v-deep .el-drawer {
  width: 40% !important;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px !important;
  box-shadow: none !important;
}
::v-deep .el-radio-button__inner {
  border: 1px solid #dcdfe6 !important;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 4px !important;
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  box-shadow: 0 0 0 0 #409eff;
}
::v-deep .el-checkbox-button__inner {
  border: 1px solid #dcdfe6 !important;
}
::v-deep .el-checkbox-button:first-child .el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px !important;
  box-shadow: none !important;
}
::v-deep .el-checkbox-button:last-child .el-checkbox-button__inner {
  border-radius: 4px !important;
}
::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  box-shadow: 0 0 0 0 #409eff;
}

.demo-drawer__content {
  padding: 0 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.demo-drawer__footer {
  border-top: 1px solid #ddd;
  padding: 10px 30px;
  display: flex;
  justify-content: right;
}
.content_top_right_user {
  width: 40px;
  height: 40px;
  margin-left: -20px;
  border-radius: 50%;
}
.content_top_right_user:first-of-type {
  margin-left: 0px;
}
</style>
